import React, {Component} from "react";
import "./QualityComplaints.css";
import {FormattedMessage} from "react-intl";
import {Redirect} from 'react-router'
import FormFieldValidationError from '../../../../Common/FormFieldValidationError/FormFieldValidationError';
import axios from "axios";
import {RESOURCE_BASE_URL} from "../../../../../configuration";
import {ReCaptcha} from 'react-recaptcha-google';
import {Modal} from "react-bootstrap";
import {toast, ToastContainer} from "react-toastify";
import {css} from "glamor";
import 'react-toastify/dist/ReactToastify.css';

toast.configure();
class QualityComplaints extends Component {

    constructor(props, context) {
        super(props, context);
        this.onLoadRecaptcha = this.onLoadRecaptcha.bind(this);
        this.verifyCallback = this.verifyCallback.bind(this);

        let today = new Date();
        let date = today.getFullYear() + ' - ' + (today.getMonth() + 1) + ' - ' + today.getDate();

        this.state = {
            orderId: props.details.orderNo,
            itemNo: this.props.details.orderItem.orderUUID,
            barcode: props.details.orderItem.barcode,
            subject: "",
            complaint: "",
            subjectError: "",
            complaintError: "",
            date: date,
            redirect: false,
            reCaptchaResponse: "",
            btnDisabled: false,  // todo Turn this to true when recaptcha is needed
            files: [],
            attachments:[]
        };

        this.onInputChange = this.onInputChange.bind(this);
        // this.validateFiles = this.validateFiles.bind(this);
        this.validateComplaint = this.validateComplaint.bind(this);
        this.saveComplaint = this.saveComplaint.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.clickFileInput = this.clickFileInput.bind(this);

    }

    validateComplaint = () => {
        let complaint = this.state.complaint;
        return (complaint !== "");
    };

    /*validateFiles = () =>{
      let files = this.state.files;
      if(files.size > "10mb"){
          this.setState({
              fileError: "app.validation.complaint.invalid-file"
          });
          return false;
      }
      return true;
    };*/

    onInputChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value,
            complaintError: ""
        });
    };

    onFileInputChange = (event) => {

        let fileExtensionRegEx = /\.((bmp)|(jpg)|(tiff)|(jpeg)|(png)|(gif))$/;

        if(!event.target.value.match(fileExtensionRegEx)){
            toast( <FormattedMessage id="app.quality-complaint-file-upload-error"
                                     defaultMessage="Error: Only image files can be attached"
                                     description=""/>,
                {className: css({
                        background: "#fa0000 !important",
                        width: "auto",
                        padding:"20px",
                        color: "#E5E5E5 !important",
                        fontWeight: "bold"
                    })
                }, {autoClose :2000});
            event.target.value = '';
        }

        let state = this.state;
        state.files = event.target.files;
        this.setState(state);
        this.state.attachments=event.target.files;
        this.onInputChange(event);
    };

    handleClose = () => {
       this.setState({
           subject: "",
           complaint:"",
           complaintError: ""
       });
        this.setState({show: false});
        this.setState({attachments:[]});
    };

    handleShow = () => {
        this.setState({show: true});
    };


    saveComplaint = () => {
        let {orderId, itemNo, files, complaint} = this.state;

        let axiosConfig = {
            headers: {
                'Content-Type': 'multipart/form-data',
                "Access-Control-Allow-Origin": "*",
            }
        };

        let formData = new FormData();

        formData.append("message", complaint);
        formData.append("subject", "MANUFACTURING_ISSUE");
        formData.append("replyToEmail", this.props.email);
        formData.append("complaintUserName", this.props.details.order.userInfo.username);

        for(let i in files){
            let file = files[i];
            if(file instanceof Blob){
                formData.append("attachments[" + i +"]", file);
            }
        }

        axios.post(RESOURCE_BASE_URL + 'api/quality-complaint/user/'+this.props.details.order.userInfo.id+'/order/'+ orderId + '/item/' + itemNo+'/create',
            formData,
            // {
            //     message: complaint,
            //     replyToEmail: this.props.email,
            //     complaintUserName: this.props.details.order.userInfo.username,
            //     userId: this.props.details.order.userInfo.id,
            //     subject: "MANUFACTURING_ISSUE"
            //     /*hasNewRepliesToUser : false,
            //     hasNewRepliesToAdmin: false,
            //     complaintReplies : [],
            //     isMailReplyRequired: false,
            //     attachmentList:[],
            //     attachmentPaths: []*/
            // },
            axiosConfig)
            .then((res) => {
                toast( <FormattedMessage id="app.quality-complaint-send-success"
                                         defaultMessage="Your complaint has been sent successfully."
                                         description=""/>,
                    {className: css({
                        background: "#ff9900 !important",
                        width: "auto",
                        padding:"25px",
                        color:"#000000 !important",
                        fontWeight: "bold"
                    })},
                    {autoClose :2000});
                this.handleClose();
            })
            .catch((err) => {
                console.log("API ERROR: ", err);
                toast(<FormattedMessage id="app.quality-complaint-send-fail"
                                        defaultMessage="Error occurred. Please try again."
                                        description=""/>,
                    {className: css({
                        background: "#fa0000 !important",
                        width: "auto",
                        padding:"20px",
                        color: "#E5E5E5 !important",
                        fontWeight: "bold"
                    })}, {autoClose :2000});
            });
    };

    onSubmit = event => {

        event.preventDefault();

        let complaintError = "";
        let validationPassed = true;

        if (!this.validateComplaint(event)) {
            validationPassed = false;
            complaintError = "app.validation.complaint.invalid-complaint";
        }

        if (validationPassed) {
            /*if (this.captchaDemo) {
                this.captchaDemo.reset();
            }*/
            this.saveComplaint();
        } else {

            this.setState({complaintError});
        }
    };

    onLoadRecaptcha() {
        if (this.captchaDemo) {
            this.captchaDemo.reset();
        }
    }

    verifyCallback(recaptchaToken) {
        this.setState({
            btnDisabled: false,
            reCaptchaResponse: recaptchaToken
        });
    }

    clickFileInput() {
        document.getElementById("complaintFiles").click();
    }

    displayFileNames() {
        let table = [];

            for (let j = 0; j < this.state.attachments.length; j++) {
                table.push(<p className="file-upld-name">{this.state.attachments[j].name}</p>);
            }

        return table
    }

    render() {
        let today = new Date();
        const {redirect} = this.state;
        let fileUrl = RESOURCE_BASE_URL + 'api/quality-complaint/files/upload' ;

        if (redirect) {
            return <Redirect to=''/>;
        }

        return (
            <span>
                    <a className="qualitycomplaints" onClick={this.handleShow}>
                        <FormattedMessage id="app.order.history.item.quality-complaints"
                                          defaultMessage="Quality Complaints"
                                          description=""/>
                    </a>
                <ToastContainer position={toast.POSITION.TOP_CENTER} hideProgressBar={true}/>

                <Modal dialogClassName="complaint-modal" show={this.state.show} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <div className="title-1 color-text">
                           <FormattedMessage id="app.quality-complaint-modal"
                                             defaultMessage="Quality Complaints"
                                             description=""/>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="contact-form-text">
                             {/*<QualityComplaints details={this.props} closeModal={this.handleClose}/>*/}
                            <div className="quality-complaint-form-content">
                <div className="quality-complaint-form-div">
                    {/*<form onSubmit={this.onSubmit}>*/}

                        <div className="row">
                            <div className="quality-complaint-form-row-margin">
                                <div className="col-md-6 quality-complaints-fields-mobile">
                                    <div className="col-md-4">
                                        <div className="text-right">
                                            <label>
                                                <FormattedMessage id="app.quality-com-form.date"
                                                                  defaultMessage="Date"
                                                                  description=""/>:
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-md-8">
                                        <label>
                                            {/*{today.getFullYear()} 年 {today.getMonth()} 月 {today.getDate()} 日*/}
                                            {today.getFullYear() + ' 年 ' + (today.getMonth() + 1) + ' 月 ' + today.getDate()+' 日'}
                                            {/*{this.state.date.substring(0,4)} 年 {this.state.date.substring(6,8)} 月
                                            {this.state.date.substring(10,12)}日*/}
                                        </label>
                                    </div>
                                </div>

                                <div className="col-md-6 quality-complaints-fields-mobile">
                                    <div className="col-md-4">
                                        <div className="text-right">
                                            <label>
                                                <FormattedMessage id="app.quality-com-form.orderId"
                                                                  defaultMessage="Order Id"
                                                                  description=""/>:
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-md-8">
                                        <label>
                                            {this.props.orderItem.barcode}
                                        </label>
                                    </div>
                                </div>

                            </div>
                        </div>


                        <div className="row">
                            <div className="quality-complaint-form-row-margin">
                                <div className="col-md-2 quality-complaint-field-headings">
                                    <div className="text-right">
                                        <label>
                                            <FormattedMessage id="app.quality-com-form.email"
                                                              defaultMessage="Email"
                                                              description=""/>
                                            {/*<span className="mandatory-star"> *</span>*/}
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-9 no-padding-left">
                                    <input type="text"
                                           className="form-control input-sm"
                                           name="email"
                                           value={this.props.email}
                                           disabled={true}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="quality-complaint-form-row-margin">
                                <div className="col-md-2 quality-complaint-field-headings">
                                    <div className="text-right">
                                        <label>
                                           件名
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-9 no-padding-left">
                                    <input type="text"
                                           className="form-control input-sm"
                                           name="subject"
                                           value={"品質異常報告 "+this.state.barcode}
                                           disabled={true}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-offset-2">
                                <FormFieldValidationError errors={this.state.subjectError}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="quality-complaint-form-row-margin">
                                <div className="col-md-2 quality-complaint-field-headings">
                                    <div className="text-right">
                                        <label>
                                            <FormattedMessage id="app.quality-com-form.complaint"
                                                              defaultMessage="Complaint"
                                                              description=""/>
                                            <span className="mandatory-star"> *</span>
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-9 no-padding-left complaint-text-area-resp">
                                    <textarea type="text"
                                              className="form-control complaint-text-area"
                                              name="complaint"
                                              value={this.state.complaint}
                                              onChange={this.onInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-offset-2">
                                <FormFieldValidationError errors={this.state.complaintError}/>
                            </div>
                        </div>

                        <div className="row">
                            <div className="quality-complaint-form-row-margin">
                                <div className="col-md-2">
                                </div>
                                <div className="col-md-9 no-padding-left">
                                    <input type="file" accept="image/*" id="complaintFiles" className="form-control file-compl" multiple
                                           onChange={this.onFileInputChange} hidden={true}/>
                                    <div>
                                        <span className="small">
                                            <FormattedMessage id="app.quality-com-form.complaint-file.select-message"
                                                              defaultMessage="If there is a file about the report content, please upload it"
                                                              description=""/>
                                        </span>
                                    </div>
                                    <br/>
                                    <div className="col-md-4 no-padding-left">&nbsp;</div>
                                    <div className="col-md-4 no-padding-left">
                                        <p>{this.displayFileNames()}</p>
                                    </div>
                                    <div className="col-md-4 text-right no-padding-right no-margin">
                                         <button className=" form-control btn btn-default file-btn complaint-file-upload-resp" onClick={this.clickFileInput}>
                                             ファイルを選択
                                         </button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    <br/>
                        <div className="row">
                            <div className="col-md-offset-2">
                                {/*<FormFieldValidationError errors={this.state.fileError}/>*/}
                            </div>
                        </div>

                        {/*<div className="row">//TODO:  uncomment this code for enabling re-captcha
                            <div className="quality-complaint-form-row-margin">
                                <div className="col-md-offset-2">
                                    <div>
                                         <ReCaptcha
                                             ref={(el) => {
                                                 this.captchaDemo = el;
                                             }}
                                             size="normal"
                                             render="explicit"
                                             data-theme="dark"
                                             sitekey="6LfJfI8UAAAAAOVOMsDTvwOSInfUZFwDrxumxImg"
                                             onloadCallback={this.onLoadRecaptcha}
                                             verifyCallback={this.verifyCallback}
                                         />
                                    </div>
                                </div>
                            </div>
                        </div>*/}



                        <div className="row">
                            <div className="quality-complaint-form-row-margin">
                                <div className="col-md-9 col-md-offset-2 text-right">
                                    <button className="btn btn-success btn-send-quality-complaint" type="" disabled={this.state.btnDisabled} onClick={this.onSubmit}>

                                        <FormattedMessage id="app.quality-com-form.send"
                                                          defaultMessage="Send"
                                                          description=""/>
                                    </button>
                                </div>
                            </div>
                        </div>
                    {/*</form>*/}
                </div>
            </div>
                        </div>

                    </Modal.Body>

                </Modal>
            </span>
        )
    }
}

export default QualityComplaints;



// WEBPACK FOOTER //
// ./src/components/Site/Order/OrderHistory/QualityComplaints/QualityComplaints.js